(function(){


var SIZE_CHART = {
  XS: { bust:[80,84], underbust:[68,72], waist:[60,64], hips:[85,89] },
  S:  { bust:[85,89], underbust:[73,77], waist:[65,69], hips:[90,94] },
  M:  { bust:[90,94], underbust:[78,82], waist:[70,74], hips:[95,99] },
  L:  { bust:[95,99], underbust:[83,87], waist:[75,79], hips:[100,104] },
  XL: { bust:[100,105], underbust:[88,93], waist:[80,85], hips:[105,110] }
};
var SIZE_ORDER = ["XS","S","M","L","XL"];


var BRA_TO_TOP_SIZE = {
  70: { A:"XS", B:"XS", C:"S",  D:"S",  E:"M",  F:"M" },
  75: { A:"XS", B:"S",  C:"S",  D:"M",  E:"M",  F:"L" },
  80: { A:"S",  B:"S",  C:"M",  D:"M",  E:"L",  F:"L" },
  85: { A:"S",  B:"M",  C:"M",  D:"L",  E:"L",  F:"XL" },
  90: { A:"M",  B:"M",  C:"L",  D:"L",  E:"XL", F:"XL" },
  95: { A:"M",  B:"L",  C:"L",  D:"XL", E:"XL", F:"XL" }
};
var STRONG_CUPS = ["D","E","F"];


var CSS_TEXT =".flowherSG_trigger{margin:12px 0 12px;font-family:inherit;}" +
".flowherSG_link{font-size:12px;letter-spacing:.02em;text-transform:uppercase;text-decoration:underline;color:#1A1A1A;background:none;padding:0;display:inline-block;cursor:pointer;font-weight:400;font-family:inherit;}" +
".flowherSG_link:hover{color:#8A8A8A;}" +
"#flowherSG_overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0);z-index:9998;opacity:0;pointer-events:none;transition:opacity .25s ease, background .25s ease;}" +
"#flowherSG_drawer{position:fixed;z-index:9999;background:#FFFEFC;display:flex;flex-direction:column;transform:translateY(100%);transition:transform .32s cubic-bezier(.22,.61,.36,1);bottom:0;left:0;right:0;top:5%;border-radius:16px 16px 0 0;box-sizing:border-box;font-family:\"Swiss721LightExtendedBT\",\"Helvetica Neue\",Arial,sans-serif;visibility:hidden;}" +
"#flowherSG_drawer *{box-sizing:border-box;font-family:inherit;}" +
"#flowherSG_drawer.flowherSG_isOpen{transform:translateY(0);visibility:visible;}" +
"#flowherSG_overlay.flowherSG_isOpen{background:rgba(0,0,0,.35);opacity:1;pointer-events:auto;}" +
"@media (min-width:768px){#flowherSG_drawer{top:50%;left:50%;bottom:auto;right:auto;width:640px;max-height:88vh;transform:translate(-50%,-46%) scale(.98);opacity:0;border-radius:4px;transition:transform .28s ease, opacity .28s ease;}#flowherSG_drawer.flowherSG_isOpen{transform:translate(-50%,-50%) scale(1);opacity:1;}}" +
".flowherSG_header{padding:22px 24px 14px;border-bottom:1px solid #E8E5E0;position:relative;flex-shrink:0;}" +
".flowherSG_title{font-size:18px;letter-spacing:.02em;margin-bottom:6px;color:#1A1A1A;}" +
".flowherSG_subtitle{font-size:13px;color:#6B6B6B;line-height:1.5;max-width:88%;}" +
".flowherSG_close{position:absolute;top:20px;right:20px;background:none;border:none;font-size:16px;cursor:pointer;padding:4px;color:#1A1A1A;}" +
".flowherSG_body{padding:20px 24px 32px;overflow-y:auto;flex:1;}" +
".flowherSG_block{margin-bottom:8px;border:1px solid #E8E5E0;border-radius:4px;overflow:hidden;}" +
".flowherSG_block + .flowherSG_block{margin-top:20px;}" +
".flowherSG_blockHeader{padding:16px 18px;background:#F6F4F0;display:flex;align-items:center;justify-content:space-between;}" +
".flowherSG_blockTitle{font-size:14px;letter-spacing:.03em;text-transform:uppercase;color:#1A1A1A;}" +
".flowherSG_resultChip{font-size:13px;padding:5px 12px;border:1px solid #1A1A1A;border-radius:20px;min-width:34px;text-align:center;display:none;color:#1A1A1A;}" +
".flowherSG_resultChip.flowherSG_visible{display:inline-block;}" +
".flowherSG_blockBody{padding:18px;}" +
".flowherSG_methodToggle{display:flex;border:1px solid #E8E5E0;border-radius:20px;overflow:hidden;margin-bottom:18px;width:fit-content;}" +
".flowherSG_methodBtn{padding:8px 16px;font-size:11.5px;background:transparent;border:none;cursor:pointer;color:#6B6B6B;letter-spacing:.02em;}" +
".flowherSG_methodBtn.flowherSG_active{background:#1A1A1A;color:#FFFEFC;}" +
".flowherSG_methodPanel{display:none;}" +
".flowherSG_methodPanel.flowherSG_active{display:block;}" +
".flowherSG_selectorGroup{margin-bottom:14px;}" +
".flowherSG_selectorLabel{font-size:11px;letter-spacing:.05em;text-transform:uppercase;color:#6B6B6B;margin-bottom:8px;display:block;}" +
".flowherSG_chipGrid{display:grid;grid-template-columns:repeat(6,1fr);gap:6px;}" +
".flowherSG_chipSelect{border:1px solid #E8E5E0;background:transparent;padding:12px 0;font-size:13px;cursor:pointer;border-radius:2px;text-align:center;color:#1A1A1A;}" +
".flowherSG_chipSelect.flowherSG_selected{border-color:#1A1A1A;background:#1A1A1A;color:#FFFEFC;}" +
".flowherSG_field{margin-bottom:14px;}" +
".flowherSG_fieldLabelRow{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:6px;}" +
".flowherSG_fieldLabel{font-size:12.5px;color:#1A1A1A;}" +
".flowherSG_howtoLink{font-size:11px;color:#6B6B6B;text-decoration:underline;background:none;border:none;cursor:pointer;padding:0;}" +
".flowherSG_inputWrap{position:relative;}" +
".flowherSG_input{width:100%;padding:13px 40px 13px 14px;border:1px solid #E8E5E0;border-radius:2px;font-size:16px;background:#FFFEFC;color:#1A1A1A;}" +
".flowherSG_input:focus{outline:none;border-color:#1A1A1A;}" +
".flowherSG_unit{position:absolute;right:14px;top:50%;transform:translateY(-50%);font-size:12.5px;color:#6B6B6B;pointer-events:none;}" +
".flowherSG_fieldsPair{display:grid;grid-template-columns:1fr 1fr;gap:12px;}" +
".flowherSG_howto{display:none;background:#F6F4F0;border-radius:2px;padding:12px 14px;margin-top:6px;font-size:12px;color:#6B6B6B;line-height:1.55;grid-column:1/-1;}" +
".flowherSG_howto.flowherSG_open{display:block;}" +
".flowherSG_miniCta{width:100%;padding:12px;background:#1A1A1A;color:#FFFEFC;border:none;border-radius:2px;font-size:12.5px;letter-spacing:.03em;text-transform:uppercase;cursor:pointer;margin-top:4px;}" +
".flowherSG_note{font-size:12.5px;color:#6B6B6B;line-height:1.55;margin-top:12px;padding-top:12px;border-top:1px solid #E8E5E0;display:none;}" +
".flowherSG_note.flowherSG_visible{display:block;}" +
".flowherSG_warning{font-size:12px;color:#8a6d3b;background:#FBF6EC;padding:10px 12px;border-radius:2px;line-height:1.5;margin-top:10px;display:none;}" +
".flowherSG_warning.flowherSG_visible{display:block;}" +
".flowherSG_errorBlocking{font-size:12.5px;color:#B23B3B;background:#FBEAEA;border:1px solid #E5B8B8;padding:12px 14px;border-radius:2px;line-height:1.5;margin-top:12px;display:none;}" +
".flowherSG_errorBlocking.flowherSG_visible{display:block;}" +
".flowherSG_summary{margin-top:24px;padding:20px;background:#F6F4F0;border-radius:4px;display:none;}" +
".flowherSG_summary.flowherSG_visible{display:block;}" +
".flowherSG_summaryLabel{font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6B6B6B;margin-bottom:10px;}" +
".flowherSG_summarySizes{display:flex;gap:28px;margin-bottom:12px;}" +
".flowherSG_summaryItemLabel{font-size:11px;color:#6B6B6B;margin-bottom:3px;}" +
".flowherSG_summaryItemValue{font-size:26px;letter-spacing:.02em;color:#1A1A1A;}" +
".flowherSG_summaryNote{font-size:12.5px;color:#6B6B6B;line-height:1.6;margin-bottom:16px;}" +
".flowherSG_ctaFinal{width:100%;padding:16px;background:#1A1A1A;color:#FFFEFC;border:none;border-radius:2px;font-size:13.5px;letter-spacing:.04em;text-transform:uppercase;cursor:pointer;}" +
".flowherSG_ctaFinal:disabled{background:#E8E5E0;color:#6B6B6B;cursor:not-allowed;}" +
".flowherSG_tableToggle{width:100%;text-align:left;background:none;border:none;border-top:1px solid #E8E5E0;padding:16px 0;font-size:13px;cursor:pointer;display:flex;justify-content:space-between;align-items:center;margin-top:22px;color:#1A1A1A;}" +
".flowherSG_tableContent{display:none;}" +
".flowherSG_tableContent.flowherSG_open{display:block;}" +
".flowherSG_sizeTable{width:100%;border-collapse:collapse;font-size:12px;margin-top:8px;}" +
".flowherSG_sizeTable th,.flowherSG_sizeTable td{padding:9px 5px;text-align:center;border-bottom:1px solid #E8E5E0;color:#1A1A1A;}" +
".flowherSG_sizeTable th{color:#6B6B6B;font-weight:400;font-size:10.5px;text-transform:uppercase;}" +
".flowherSG_sizeTable td:first-child,.flowherSG_sizeTable th:first-child{text-align:left;font-weight:500;}" +
"@media (max-width:400px){.flowherSG_sizeTable{font-size:10.5px;}.flowherSG_sizeTable th,.flowherSG_sizeTable td{padding:7px 3px;}.flowherSG_fieldsPair{grid-template-columns:1fr;}}" +
".flowherSG_reassurance{background:#F6F4F0;border-radius:2px;padding:16px 18px;margin-top:20px;}" +
".flowherSG_reassuranceTitle{font-size:13px;margin-bottom:6px;color:#1A1A1A;}" +
".flowherSG_reassuranceText{font-size:12px;color:#6B6B6B;line-height:1.6;}" +
".flowherSG_modelRef{font-size:11.5px;color:#6B6B6B;margin-top:14px;line-height:1.6;font-style:italic;}";


var TRIGGER_HTML = '<button type="button" id="flowherSG_open" class="flowherSG_link">Guide des tailles</button>';


var DRAWER_HTML =
'<div id="flowherSG_overlay"></div>' +
'<div id="flowherSG_drawer">' +
  '<div class="flowherSG_header">' +
    '<button type="button" id="flowherSG_close" class="flowherSG_close">X</button>' +
    '<div class="flowherSG_title">Guide des tailles</div>' +
    '<div class="flowherSG_subtitle">Trouvez votre taille en quelques secondes. Le haut et le bas se choisissent independamment : testez chacun ci-dessous.</div>' +
  '</div>' +
  '<div class="flowherSG_body">' +
    '<div class="flowherSG_block">' +
      '<div class="flowherSG_blockHeader"><span class="flowherSG_blockTitle">Haut</span><span class="flowherSG_resultChip" id="flowherSG_topChip">-</span></div>' +
      '<div class="flowherSG_blockBody">' +
        '<div class="flowherSG_methodToggle">' +
          '<button type="button" class="flowherSG_methodBtn flowherSG_active" data-method="bra">Soutien-gorge</button>' +
          '<button type="button" class="flowherSG_methodBtn" data-method="measurements">Mensurations</button>' +
        '</div>' +
        '<div class="flowherSG_methodPanel flowherSG_active" id="flowherSG_topBra">' +
          '<div class="flowherSG_selectorGroup"><span class="flowherSG_selectorLabel">Tour de dos</span>' +
            '<div class="flowherSG_chipGrid" id="flowherSG_braBand">' +
              '<button type="button" class="flowherSG_chipSelect" data-value="70">70</button>' +
              '<button type="button" class="flowherSG_chipSelect" data-value="75">75</button>' +
              '<button type="button" class="flowherSG_chipSelect" data-value="80">80</button>' +
              '<button type="button" class="flowherSG_chipSelect" data-value="85">85</button>' +
              '<button type="button" class="flowherSG_chipSelect" data-value="90">90</button>' +
              '<button type="button" class="flowherSG_chipSelect" data-value="95">95</button>' +
            '</div></div>' +
          '<div class="flowherSG_selectorGroup"><span class="flowherSG_selectorLabel">Bonnet</span>' +
            '<div class="flowherSG_chipGrid" id="flowherSG_braCup">' +
              '<button type="button" class="flowherSG_chipSelect" data-value="A">A</button>' +
              '<button type="button" class="flowherSG_chipSelect" data-value="B">B</button>' +
              '<button type="button" class="flowherSG_chipSelect" data-value="C">C</button>' +
              '<button type="button" class="flowherSG_chipSelect" data-value="D">D</button>' +
              '<button type="button" class="flowherSG_chipSelect" data-value="E">E</button>' +
              '<button type="button" class="flowherSG_chipSelect" data-value="F">F</button>' +
            '</div></div>' +
          '<div class="flowherSG_note" id="flowherSG_braNote"></div>' +
          '<div class="flowherSG_warning" id="flowherSG_braWarning"></div>' +
        '</div>' +
        '<div class="flowherSG_methodPanel" id="flowherSG_topMeasurements">' +
          '<div class="flowherSG_fieldsPair">' +
            '<div class="flowherSG_field"><div class="flowherSG_fieldLabelRow"><label class="flowherSG_fieldLabel">Poitrine</label><button type="button" class="flowherSG_howtoLink" data-target="flowherSG_howtoBust">Comment mesurer ?</button></div>' +
              '<div class="flowherSG_inputWrap"><input type="number" inputmode="decimal" class="flowherSG_input" id="flowherSG_mBust" placeholder="90"><span class="flowherSG_unit">cm</span></div></div>' +
            '<div class="flowherSG_field"><div class="flowherSG_fieldLabelRow"><label class="flowherSG_fieldLabel">Sous-poitrine</label><button type="button" class="flowherSG_howtoLink" data-target="flowherSG_howtoUnderbust">Comment mesurer ?</button></div>' +
              '<div class="flowherSG_inputWrap"><input type="number" inputmode="decimal" class="flowherSG_input" id="flowherSG_mUnderbust" placeholder="78"><span class="flowherSG_unit">cm</span></div></div>' +
            '<div class="flowherSG_howto" id="flowherSG_howtoBust">Mesurez horizontalement autour de la partie la plus forte de votre poitrine.</div>' +
            '<div class="flowherSG_howto" id="flowherSG_howtoUnderbust">Mesurez juste sous votre poitrine, metre ruban bien horizontal.</div>' +
          '</div>' +
          '<button type="button" class="flowherSG_miniCta" id="flowherSG_ctaTopMeasure">Calculer la taille du haut</button>' +
          '<div class="flowherSG_note" id="flowherSG_topMeasureNote"></div>' +
          '<div class="flowherSG_warning" id="flowherSG_topMeasureWarning"></div>' +
        '</div>' +
      '</div>' +
    '</div>' +
    '<div class="flowherSG_block">' +
      '<div class="flowherSG_blockHeader"><span class="flowherSG_blockTitle">Bas</span><span class="flowherSG_resultChip" id="flowherSG_bottomChip">-</span></div>' +
      '<div class="flowherSG_blockBody">' +
        '<div class="flowherSG_fieldsPair">' +
          '<div class="flowherSG_field"><div class="flowherSG_fieldLabelRow"><label class="flowherSG_fieldLabel">Taille</label><button type="button" class="flowherSG_howtoLink" data-target="flowherSG_howtoWaist">Comment mesurer ?</button></div>' +
            '<div class="flowherSG_inputWrap"><input type="number" inputmode="decimal" class="flowherSG_input" id="flowherSG_mWaist" placeholder="70"><span class="flowherSG_unit">cm</span></div></div>' +
          '<div class="flowherSG_field"><div class="flowherSG_fieldLabelRow"><label class="flowherSG_fieldLabel">Hanches</label><button type="button" class="flowherSG_howtoLink" data-target="flowherSG_howtoHips">Comment mesurer ?</button></div>' +
            '<div class="flowherSG_inputWrap"><input type="number" inputmode="decimal" class="flowherSG_input" id="flowherSG_mHips" placeholder="95"><span class="flowherSG_unit">cm</span></div></div>' +
          '<div class="flowherSG_howto" id="flowherSG_howtoWaist">Mesurez la partie la plus creuse de votre taille.</div>' +
          '<div class="flowherSG_howto" id="flowherSG_howtoHips">Mesurez autour de la partie la plus large de vos hanches.</div>' +
        '</div>' +
        '<button type="button" class="flowherSG_miniCta" id="flowherSG_ctaBottomMeasure">Calculer la taille du bas</button>' +
        '<div class="flowherSG_note" id="flowherSG_bottomMeasureNote"></div>' +
        '<div class="flowherSG_warning" id="flowherSG_bottomMeasureWarning"></div>' +
      '</div>' +
    '</div>' +
    '<div class="flowherSG_errorBlocking" id="flowherSG_errorStock"></div>' +
    '<div class="flowherSG_summary" id="flowherSG_summary">' +
      '<div class="flowherSG_summaryLabel">Votre taille recommandee</div>' +
      '<div class="flowherSG_summarySizes">' +
        '<div><div class="flowherSG_summaryItemLabel">Haut</div><div class="flowherSG_summaryItemValue" id="flowherSG_summaryTop">-</div></div>' +
        '<div><div class="flowherSG_summaryItemLabel">Bas</div><div class="flowherSG_summaryItemValue" id="flowherSG_summaryBottom">-</div></div>' +
      '</div>' +
      '<div class="flowherSG_summaryNote" id="flowherSG_summaryNote"></div>' +
      '<button type="button" class="flowherSG_ctaFinal" id="flowherSG_ctaFinal" disabled>Ajouter au panier dans cette taille</button>' +
    '</div>' +
    '<button type="button" class="flowherSG_tableToggle" id="flowherSG_tableToggle"><span>Tableau des tailles</span><span id="flowherSG_tableToggleIcon">+</span></button>' +
    '<div class="flowherSG_tableContent" id="flowherSG_tableContent">' +
      '<table class="flowherSG_sizeTable"><thead><tr><th>Taille</th><th>Poitrine</th><th>Sous-poitrine</th><th>Taille</th><th>Hanches</th></tr></thead><tbody id="flowherSG_sizeTableBody"></tbody></table>' +
      '<div class="flowherSG_modelRef">Lara mesure 164 cm, poitrine 85 cm, taille 59 cm, hanches 87 cm - elle porte un haut XS et un bas S.</div>' +
    '</div>' +
    '<div class="flowherSG_reassurance">' +
      '<div class="flowherSG_reassuranceTitle">Un maintien pres du corps, pense pour vous</div>' +
      '<div class="flowherSG_reassuranceText">Pour offrir un maintien optimal et une sensation de securite tout au long de la journee, nos maillots sont concus pour s ajuster au plus pres du corps, sans jamais comprimer. En cas de doute entre deux tailles, privilegiez toujours la taille superieure.</div>' +
    '</div>' +
  '</div>' +
'</div>';


function injectStyles(){
  if (document.getElementById("flowherSG_styles")) { return; }
  var style = document.createElement("style");
  style.id = "flowherSG_styles";
  style.textContent = CSS_TEXT;
  document.head.appendChild(style);
}


function injectTrigger(){
  var addToCartBtn = document.querySelector(".product-form__submit.add-to-cart");
  if (!addToCartBtn) { return false; }
  if (document.getElementById("flowherSG_open")) { return true; }
  var wrapper = document.createElement("div");
  wrapper.className = "flowherSG_trigger";
  wrapper.innerHTML = TRIGGER_HTML;
  addToCartBtn.parentNode.insertBefore(wrapper, addToCartBtn);
  return true;
}


function injectDrawer(){
  if (document.getElementById("flowherSG_drawer")) { return; }
  var wrapper = document.createElement("div");
  wrapper.id = "flowherSG_root";
  wrapper.innerHTML = DRAWER_HTML;
  document.body.appendChild(wrapper);
}


function findSizeForValue(value, key){
  for (var i=0; i<SIZE_ORDER.length; i++){
    var size = SIZE_ORDER[i];
    var range = SIZE_CHART[size][key];
    if (value >= range[0] && value <= range[1]) return size;
  }
  if (value < SIZE_CHART[SIZE_ORDER[0]][key][0]) return SIZE_ORDER[0];
  if (value > SIZE_CHART[SIZE_ORDER[SIZE_ORDER.length-1]][key][1]) return SIZE_ORDER[SIZE_ORDER.length-1];
  for (var j=0; j<SIZE_ORDER.length-1; j++){
    var currentMax = SIZE_CHART[SIZE_ORDER[j]][key][1];
    var nextMin = SIZE_CHART[SIZE_ORDER[j+1]][key][0];
    if (value > currentMax && value < nextMin) return SIZE_ORDER[j+1];
  }
  return SIZE_ORDER[Math.floor(SIZE_ORDER.length/2)];
}
function sizeIndex(size){ return SIZE_ORDER.indexOf(size); }
function upgradeSize(size){
  var idx = sizeIndex(size);
  return idx < SIZE_ORDER.length-1 ? SIZE_ORDER[idx+1] : size;
}
function recommendTopFromMeasurements(bust, underbust){
  var bustSize = findSizeForValue(bust, "bust");
  var underbustSize = findSizeForValue(underbust, "underbust");
  var topSize = sizeIndex(bustSize) >= sizeIndex(underbustSize) ? bustSize : underbustSize;
  var inconsistent = (underbust >= bust) || (bust - underbust < 4);
  return { topSize: topSize, inconsistent: inconsistent };
}
function recommendBottomFromMeasurements(waist, hips){
  var waistSize = findSizeForValue(waist, "waist");
  var hipsSize = findSizeForValue(hips, "hips");
  var bottomSize = hipsSize;
  if (sizeIndex(waistSize) - sizeIndex(hipsSize) >= 2){ bottomSize = upgradeSize(hipsSize); }
  var inconsistent = (waist >= hips);
  return { bottomSize: bottomSize, inconsistent: inconsistent };
}
function recommendFromBra(band, cup){
  var row = BRA_TO_TOP_SIZE[band];
  if (!row) return null;
  return row[cup] || null;
}


var state = { top: null, bottom: null };


function openDrawer(){
  var drawer = document.getElementById("flowherSG_drawer");
  var overlay = document.getElementById("flowherSG_overlay");
  if (!drawer || !overlay) { return; }
  drawer.classList.add("flowherSG_isOpen");
  overlay.classList.add("flowherSG_isOpen");
  document.body.style.overflow = "hidden";
}
function closeDrawer(){
  var drawer = document.getElementById("flowherSG_drawer");
  var overlay = document.getElementById("flowherSG_overlay");
  if (!drawer || !overlay) { return; }
  drawer.classList.remove("flowherSG_isOpen");
  overlay.classList.remove("flowherSG_isOpen");
  document.body.style.overflow = "";
}


function findAllFieldsets(){
  var candidates = document.querySelectorAll(".swatch-wrapper, fieldset");
  var results = [];
  for (var i=0; i<candidates.length; i++){
    var fs = candidates[i];
    var legend = fs.querySelector(".swatch-header, legend");
    var radios = fs.querySelectorAll("input[type=radio]");
    if (legend && radios.length > 0){
      results.push({ el: fs, label: legend.textContent.trim().toLowerCase(), radios: radios });
    }
  }
  return results;
}


function findFieldsetByExactKeywords(keywords){
  var all = findAllFieldsets();
  for (var i=0; i<all.length; i++){
    for (var k=0; k<keywords.length; k++){
      if (all[i].label.indexOf(keywords[k]) !== -1) { return all[i]; }
    }
  }
  return null;
}


function getRadioFromFieldset(fieldset, sizeValue){
  if (!fieldset) return null;
  for (var r=0; r<fieldset.radios.length; r++){
    var radio = fieldset.radios[r];
    if (radio.value.replace(/^\s+|\s+$/g, "").toUpperCase() === sizeValue){ return radio; }
  }
  return null;
}


function bindAll(){
  var drawer = document.getElementById("flowherSG_drawer");
  var overlay = document.getElementById("flowherSG_overlay");
  var openBtn = document.getElementById("flowherSG_open");
  var closeBtn = document.getElementById("flowherSG_close");
  if (!drawer || !overlay || !openBtn || !closeBtn) { return; }
  if (openBtn.getAttribute("data-bound") === "1") { return; }
  openBtn.setAttribute("data-bound", "1");


  openBtn.addEventListener("click", function(e){ e.preventDefault(); openDrawer(); });
  closeBtn.addEventListener("click", function(e){ e.preventDefault(); closeDrawer(); });
  overlay.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", function(e){ if(e.key==="Escape") closeDrawer(); });


  function resolveFieldsets(){
    var topFieldset = findFieldsetByExactKeywords(["taille pour le haut", "taille haut", "size top"]);
    var bottomFieldset = findFieldsetByExactKeywords(["taille pour le bas", "taille bas", "size bottom"]);
    if (!topFieldset || !bottomFieldset){
      var allTailleFieldsets = findAllFieldsets().filter(function(fs){
        return fs.label.indexOf("taille") !== -1 || fs.label.indexOf("size") !== -1;
      });
      if (!topFieldset && allTailleFieldsets[0]) topFieldset = allTailleFieldsets[0];
      if (!bottomFieldset && allTailleFieldsets[1]) bottomFieldset = allTailleFieldsets[1];
    }
    return { top: topFieldset, bottom: bottomFieldset };
  }


  function refreshStockState(){
    var errorStock = document.getElementById("flowherSG_errorStock");
    var ctaFinal = document.getElementById("flowherSG_ctaFinal");
    if (!state.top || !state.bottom) { errorStock.classList.remove("flowherSG_visible"); return; }

    var fieldsets = resolveFieldsets();
    var topRadio = getRadioFromFieldset(fieldsets.top, state.top);
    var bottomRadio = getRadioFromFieldset(fieldsets.bottom, state.bottom);

    var missing = [];
    if (!topRadio || topRadio.disabled) missing.push("haut (" + state.top + ")");
    if (!bottomRadio || bottomRadio.disabled) missing.push("bas (" + state.bottom + ")");

    if (missing.length > 0){
      errorStock.textContent = "Rupture de stock ou taille indisponible pour : " + missing.join(", ") + ". Ajout au panier impossible.";
      errorStock.classList.add("flowherSG_visible");
      ctaFinal.disabled = true;
    } else {
      errorStock.classList.remove("flowherSG_visible");
      ctaFinal.disabled = false;
    }
  }


  function updateSummary(){
    var chipTop = document.getElementById("flowherSG_topChip");
    var chipBottom = document.getElementById("flowherSG_bottomChip");
    chipTop.textContent = state.top || "-";
    chipTop.classList.toggle("flowherSG_visible", !!state.top);
    chipBottom.textContent = state.bottom || "-";
    chipBottom.classList.toggle("flowherSG_visible", !!state.bottom);


    var summary = document.getElementById("flowherSG_summary");
    var ctaFinal = document.getElementById("flowherSG_ctaFinal");


    if (!state.top && !state.bottom){ summary.classList.remove("flowherSG_visible"); return; }
    summary.classList.add("flowherSG_visible");
    document.getElementById("flowherSG_summaryTop").textContent = state.top || "-";
    document.getElementById("flowherSG_summaryBottom").textContent = state.bottom || "-";


    var note = "";
    if (state.top && state.bottom){
      note = (state.top === state.bottom)
        ? "Le haut et le bas correspondent a la meme taille, pour un maintien homogene sur l ensemble."
        : "Chez FLOWHER, le haut et le bas se choisissent independamment. Nous vous recommandons " + state.top + " pour le haut et " + state.bottom + " pour le bas.";
      ctaFinal.disabled = false;
      refreshStockState();
    } else if (state.top){
      note = "Renseignez egalement votre taille de bas ci-dessus pour completer votre recommandation.";
      ctaFinal.disabled = true;
    } else if (state.bottom){
      note = "Renseignez egalement votre taille de haut ci-dessus pour completer votre recommandation.";
      ctaFinal.disabled = true;
    }
    document.getElementById("flowherSG_summaryNote").textContent = note;
  }


  var methodBtns = drawer.querySelectorAll(".flowherSG_methodBtn");
  for (var m=0; m<methodBtns.length; m++){
    methodBtns[m].addEventListener("click", function(){
      for (var k=0; k<methodBtns.length; k++){ methodBtns[k].classList.remove("flowherSG_active"); }
      this.classList.add("flowherSG_active");
      document.getElementById("flowherSG_topBra").classList.remove("flowherSG_active");
      document.getElementById("flowherSG_topMeasurements").classList.remove("flowherSG_active");
      var target = this.getAttribute("data-method") === "bra" ? "flowherSG_topBra" : "flowherSG_topMeasurements";
      document.getElementById(target).classList.add("flowherSG_active");
    });
  }


  var howtoLinks = drawer.querySelectorAll(".flowherSG_howtoLink");
  for (var h=0; h<howtoLinks.length; h++){
    howtoLinks[h].addEventListener("click", function(){
      var target = document.getElementById(this.getAttribute("data-target"));
      var allHowtos = drawer.querySelectorAll(".flowherSG_howto");
      for (var n=0; n<allHowtos.length; n++){ if (allHowtos[n] !== target) allHowtos[n].classList.remove("flowherSG_open"); }
      target.classList.toggle("flowherSG_open");
    });
  }


  var braBandValue = null, braCupValue = null;
  var braBandChips = document.querySelectorAll("#flowherSG_braBand .flowherSG_chipSelect");
  var braCupChips = document.querySelectorAll("#flowherSG_braCup .flowherSG_chipSelect");


  function tryComputeBra(){
    if (braBandValue === null || braCupValue === null) return;
    var size = recommendFromBra(braBandValue, braCupValue);
    var note = document.getElementById("flowherSG_braNote");
    var warning = document.getElementById("flowherSG_braWarning");
    if (!size){
      warning.textContent = "Cette combinaison n est pas encore referencee. Contactez-nous, nous vous aiderons a trouver votre taille.";
      warning.classList.add("flowherSG_visible");
      note.classList.remove("flowherSG_visible");
      state.top = null;
      updateSummary();
      return;
    }
    warning.classList.remove("flowherSG_visible");
    var noteText = STRONG_CUPS.indexOf(braCupValue) !== -1 ? ("Votre bonnet " + braCupValue + " a ete pris en compte en priorite pour garantir un maintien optimal.") : "";
    note.textContent = noteText;
    note.classList.toggle("flowherSG_visible", !!noteText);
    state.top = size;
    updateSummary();
  }


  for (var b=0; b<braBandChips.length; b++){
    braBandChips[b].addEventListener("click", function(){
      for (var i2=0; i2<braBandChips.length; i2++){ braBandChips[i2].classList.remove("flowherSG_selected"); }
      this.classList.add("flowherSG_selected");
      braBandValue = parseInt(this.getAttribute("data-value"), 10);
      tryComputeBra();
    });
  }
  for (var c=0; c<braCupChips.length; c++){
    braCupChips[c].addEventListener("click", function(){
      for (var i3=0; i3<braCupChips.length; i3++){ braCupChips[i3].classList.remove("flowherSG_selected"); }
      this.classList.add("flowherSG_selected");
      braCupValue = this.getAttribute("data-value");
      tryComputeBra();
    });
  }


  document.getElementById("flowherSG_ctaTopMeasure").addEventListener("click", function(){
    var bust = parseFloat(document.getElementById("flowherSG_mBust").value);
    var underbust = parseFloat(document.getElementById("flowherSG_mUnderbust").value);
    var note = document.getElementById("flowherSG_topMeasureNote");
    var warning = document.getElementById("flowherSG_topMeasureWarning");
    if (!bust || !underbust){
      warning.textContent = "Merci de renseigner votre poitrine et votre sous-poitrine.";
      warning.classList.add("flowherSG_visible");
      return;
    }
    var result = recommendTopFromMeasurements(bust, underbust);
    state.top = result.topSize;
    warning.classList.toggle("flowherSG_visible", result.inconsistent);
    if (result.inconsistent) { warning.textContent = "Ces mesures semblent inhabituelles. Verifiez que vous avez bien mesure au bon endroit."; }
    note.textContent = "Taille du haut calculee a partir de vos mensurations.";
    note.classList.add("flowherSG_visible");
    updateSummary();
  });


  document.getElementById("flowherSG_ctaBottomMeasure").addEventListener("click", function(){
    var waist = parseFloat(document.getElementById("flowherSG_mWaist").value);
    var hips = parseFloat(document.getElementById("flowherSG_mHips").value);
    var note = document.getElementById("flowherSG_bottomMeasureNote");
    var warning = document.getElementById("flowherSG_bottomMeasureWarning");
    if (!waist || !hips){
      warning.textContent = "Merci de renseigner votre taille et vos hanches.";
      warning.classList.add("flowherSG_visible");
      return;
    }
    var result = recommendBottomFromMeasurements(waist, hips);
    state.bottom = result.bottomSize;
    warning.classList.toggle("flowherSG_visible", result.inconsistent);
    if (result.inconsistent) { warning.textContent = "Ces mesures semblent inhabituelles. Verifiez que vous avez bien mesure au bon endroit."; }
    note.textContent = "Le tour de hanches est votre repere principal pour un maintien optimal du bas.";
    note.classList.add("flowherSG_visible");
    updateSummary();
  });


  function selectShopifySize(radio){
    if (!radio || radio.disabled) { return false; }
    radio.checked = true;
    radio.dispatchEvent(new Event("change", { bubbles: true }));
    radio.dispatchEvent(new Event("click", { bubbles: true }));
    var allLabels = document.getElementsByTagName("label");
    for (var lb=0; lb<allLabels.length; lb++){
      if (allLabels[lb].getAttribute("for") === radio.id){ allLabels[lb].click(); break; }
    }
    return true;
  }


  function triggerAddToCart(submitBtn){
    var form = submitBtn.closest("form");
    if (form){
      if (typeof form.requestSubmit === "function"){
        form.requestSubmit(submitBtn);
      } else {
        submitBtn.click();
        form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
      }
    } else {
      submitBtn.click();
    }
  }


  function waitForEnabledSubmitAndClick(maxAttempts){
    var attempts = 0;
    var interval = setInterval(function(){
      attempts++;
      var submitBtn = document.querySelector(".product-form__submit.add-to-cart");
      if (submitBtn && !submitBtn.disabled){
        clearInterval(interval);
        triggerAddToCart(submitBtn);
        return;
      }
      if (attempts >= maxAttempts){
        clearInterval(interval);
        if (submitBtn) { triggerAddToCart(submitBtn); }
      }
    }, 150);
  }


  document.getElementById("flowherSG_ctaFinal").addEventListener("click", function(){
    if (!state.top || !state.bottom) return;
    refreshStockState();
    var fieldsets = resolveFieldsets();
    var topRadio = getRadioFromFieldset(fieldsets.top, state.top);
    var bottomRadio = getRadioFromFieldset(fieldsets.bottom, state.bottom);
    if (!topRadio || topRadio.disabled || !bottomRadio || bottomRadio.disabled) { return; }
    var okTop = selectShopifySize(topRadio);
    var okBottom = selectShopifySize(bottomRadio);
    if (!okTop || !okBottom) return;
    closeDrawer();
    waitForEnabledSubmitAndClick(20);
  });


  var tbody = document.getElementById("flowherSG_sizeTableBody");
  var rowsHtml = "";
  for (var s=0; s<SIZE_ORDER.length; s++){
    var size = SIZE_ORDER[s];
    var d = SIZE_CHART[size];
    rowsHtml += "<tr><td>" + size + "</td><td>" + d.bust[0] + "-" + d.bust[1] + " cm</td><td>" + d.underbust[0] + "-" + d.underbust[1] + " cm</td><td>" + d.waist[0] + "-" + d.waist[1] + " cm</td><td>" + d.hips[0] + "-" + d.hips[1] + " cm</td></tr>";
  }
  tbody.innerHTML = rowsHtml;


  document.getElementById("flowherSG_tableToggle").addEventListener("click", function(){
    var content = document.getElementById("flowherSG_tableContent");
    var icon = document.getElementById("flowherSG_tableToggleIcon");
    content.classList.toggle("flowherSG_open");
    icon.textContent = content.classList.contains("flowherSG_open") ? "-" : "+";
  });
}


function init(){
  var triggerOk = injectTrigger();
  if (!triggerOk) { return; }
  injectStyles();
  injectDrawer();
  bindAll();
}


function scheduleInit(){
  init();
  setTimeout(init, 500);
  setTimeout(init, 1500);
  setTimeout(init, 3000);
}


if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", scheduleInit);
} else {
  scheduleInit();
}


})();